/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
// import Divider from "@mui/material/Divider";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Loader from "examples/Loader";
// import SoftButton from "components/SoftButton";

// Billing page components
import Transaction from "layouts/pages/account/billing/components/Transaction";
import { useEffect, useRef, useState } from "react";


function Transactions({ logs, creditslog, hasMore, loadingMore, onLoadMore }) {
  const [selectedRange, setSelectedRange] = useState("all");
  const [loading, setLoading] = useState(false); // Loading state
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!hasMore) return;
    const el = sentinelRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) onLoadMore();
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, onLoadMore]);

  const filterLogsByDate = (logs) => {
    if (selectedRange === "all") return logs;

    const today = new Date();
    const rangeInDays = parseInt(selectedRange, 10);
    const startDate = new Date(today.setDate(today.getDate() - rangeInDays));

    return logs.filter((log) => {
      const logDate = new Date(log.createdAt);
      return logDate >= startDate;
    });
  };

  const filteredLogs = filterLogsByDate(logs);
  const filteredCreditslog = filterLogsByDate(creditslog);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, [selectedRange]);

  return (
    <SoftBox pt={1} pb={1} px={1}>
      <SoftBox
        component="ul"
        display="flex"
        flexDirection="column"
        p={0}
        m={0}
        sx={{ listStyle: "none" }}
      >
        <div className="d-flex justify-content-between">
          <div className="w-50">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <h2 className="text-black font-18" style={{ margin: "10px 10px 10px 0px" }}>
                  Transactions
                </h2>
              </div>
              <div>
                <select
                  className="form-control"
                  style={{ width: "200px", marginTop: "5px", marginRight: "15px", height: "40px", borderRadius: "5px", border: "1px solid rgba(229, 229, 229, 1)" }}
                  value={selectedRange}
                  onChange={(e) => setSelectedRange(e.target.value)}
                >
                  <option value="all">All</option>
                  <option value="7">Last 7 days</option>
                  <option value="14">Last 14 days</option>
                  <option value="30">Last month</option>
                  <option value="365">Last year</option>
                </select>
              </div>
            </div>

            {loading ? (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              filteredLogs?.map((log, key) => (
                <div
                  className="bg-card bg-white"
                  style={{ margin: "10px 10px 10px 0px", border: "1px solid rgba(229, 229, 229, 1)" }}
                  key={key}
                >
                  <Transaction
                    color={log.type === "debit" ? "error" : "success"}
                    icon={log.type === "debit" ? "arrow_downward" : "arrow_upward"}
                    name={log.req_type}
                    business_name={log.business_name}
                    description={log.createdAt}
                    value={log.type === "debit" ? `- $${log.amount}` : `+ $${log.amount}`}
                  />
                </div>
              ))
            )}
          </div>
          <div className="w-50">
            <h2 className="text-black font-18" style={{ margin: "10px 0px 10px 10px" }}>Auto Charge</h2>

            {loading ? (
              <div style={{ textAlign: "center", marginTop: "20px" }}>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              filteredCreditslog?.map((log, key) => (
                <div
                  className="bg-card bg-white"
                  style={{ margin: "10px 0px 10px 10px", border: "1px solid rgba(229, 229, 229, 1)" }}
                  key={key}
                >

                  <Transaction
                    key={key}
                    color={log?.response?.status === "succeeded" ? "success" : "error"}
                    icon={log?.response?.status === "succeeded" ? "arrow_upward" : "arrow_downward"}
                    name={log.req_type}
                    business_name={log.business_name}
                    description={log.createdAt}
                    value={`${log?.response?.status == "succeeded" ? `+ $${log.amount}` : `= $${log.amount}`}`}
                  />
                  {log?.response?.status === "succeeded" ? "" : <span style={{ background: "red", color: "white", padding: "5px 10px", fontSize: "10px", borderRadius: "20px" }}>Payment Incomplete</span>}

                </div>
              ))
            )}
          </div>
        </div>
        {hasMore && (
          <div ref={sentinelRef} style={{ textAlign: "center", padding: "15px" }}>
            {loadingMore ? "Loading more..." : ""}
          </div>
        )}
      </SoftBox>
    </SoftBox>
  );
}

export default Transactions;

